import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";

const RegisterPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate("/profile"); // Переход на страницу профиля после регистрации
    } catch (err) {
      setError("Ошибка регистрации: " + err.message);
    }
  };

  return (
    <div className="container">
        <div className="home-container">
            <h1>Raytolfas - Регистрация</h1>
        </div>

        <div className="content-container">
            <h1>Регистрация</h1>
            <form onSubmit={handleRegister}>
                <div>
                <label>Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                </div>
                <div>
                <label>Пароль</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                </div>
                <button type="submit">Зарегистрироваться</button>
                {error && <p>{error}</p>}
                <p>Если у вас уже есть аккаунт тогда <Link to="/auth/login">войдите в его</Link></p>
            </form>
        </div>
    </div>
  );
};

export default RegisterPage;
